import React, { ReactNode, FC } from "react";

import { LinkList } from "../../../ActionsSelectors/LinkList";

export interface IMenuTabsListProps {
  /**
   * HTML label value
   */
  ariaLabel?: string;
  /**
   * The custom set of css classes used to style component
   *
   */
  classes?: {
    /** Styles applied to outer 'a' element. */
    root?: string;
  };
  children?: ReactNode;
}

/**
 * Helper layout component
 */
export const MobileNavList: FC<IMenuTabsListProps> = ({
  ariaLabel,
  classes,
  children,
}) => (
  <nav aria-label={ariaLabel} className={classes?.root}>
    <LinkList
      classes={{
        root: "mobile-nav-list",
      }}
    >
      {children}
    </LinkList>
  </nav>
);

export default MobileNavList;
